<!-- Topbar of the page in header section -->
<section class="nav_chnage">
  <div class="container">
<div class="row topbarlogin">
    <div class="col-md-4">
      <a class="navbar-brand"href="index.html">
        <img src="../../../assets/images/mcred_0011.png" alt="LOGO" class="logomain"/></a>
    </div>
          <nav class="navbar navbar-expand-lg navbar-light">
            <button type="button" class="navbar-toggler nav_phone_button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto nav-move-side">
              <li class="nav-item active">
                <a class="nav-link"  [routerLink]="['/mcredpro']" routerLinkActive="active">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link"  routerLink="/features" [routerLinkActive]="['active']">Features</a>
              </li>
              <!-- <li class="nav-item">
                <a class="nav-link" routerLink="/features" href="#">Demo</a>
              </li> -->
              <li class="nav-item">
                <a class="nav-link"  routerLink="/contactus" [routerLinkActive]="['active']">Contact Us</a>
              </li>
            </ul>
            </div>
           </nav>

           <!-- <div class="social_media_section">
            <p style="margin-top: 25px;
            margin-left: 70px;">
              <a href="https://www.facebook.com/manteioIT/" class="sicons" target="_blank">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </a>
              <a href="https://www.twitter.com/manteioIT" class="sicons" target="_blank">
                  <i class="fa fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/manteio_it_solutions" class="sicons" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>
              <a href="https://www.linkedin.com/company/manteiotechnologies" class="sicons" target="_blank">
                <i class="fa fa-linkedin-square" aria-hidden="true"></i>
              </a>
          </p>
           </div> -->
          <button class="login_botton" style="border-radius: 15px; height: 42px;">
            <a href="" routerLink="/login"><img src="./../../../assets/images/loginImage.png" alt=""> Login</a>
         </button>
         </div>
    </div>
</section>
